/* eslint-disable react-hooks/exhaustive-deps */
import gsap from 'gsap'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import SuperLoading from '../modules/SuperLoading'
// import SuperSelect from '../modules/SuperSelect'

import SectionHeroInternacional from '../modules/Sections/SectionsHero/SectionHeroInternacional'
import SectionSpecialtiesHorizontalScroll from '../modules/Sections/SectionsSpecialties/SectionSpecialtiesHorizontalScroll'
import SectionServicesCircularYearsExperience from '../modules/Sections/SectionsServices/SectionServicesCircularYearsExperience'
import SectionSpecialtiesCircular from '../modules/Sections/SectionsSpecialties/SectionSpecialtiesCircular'
import SectionTestimonialsCircular from '../modules/Sections/SectionsTestimonials/SectionTestimonialsCircular'
import SectionContactCircular from '../modules/Sections/SectionsContacts/SectionContactCircular'
import FooterCircular from '../modules/Footers/FooterCircular'

export default function PublicRoutes() {
  const location = useLocation()

  useEffect(() => {
    const getSelector =
      window.document.getElementsByClassName('box-superLoading')

    gsap.to(getSelector, {
      opacity: 0,
      duration: 0.5,
      delay: 2,
      onComplete: () => {
        gsap.to(getSelector, {
          zIndex: '-1',
          delay: 0.2,
          duration: 0.1,
        })
      },
    })
    setTimeout(() => {
      checkUrl()
    }, 2200)
  }, [])

  function checkUrl() {
    if (location.search.length > 2) {
      const goto = location.search.split('=')[1]

      const itemServices = window.document.getElementById('int-view-landing-03')
      const itemContacts = window.document.getElementById('int-view-landing-05')
      const itemAbout = window.document.getElementById('int-view-landing-02')

      if (goto === 'about') {
        itemAbout?.scrollIntoView({ behavior: 'smooth' })
      } else if (goto === 'services') {
        itemServices?.scrollIntoView({ behavior: 'smooth' })
      } else if (goto === 'contacts') {
        itemContacts?.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <>
      <SuperLoading />
      <SectionHeroInternacional />
      <SectionServicesCircularYearsExperience />
      <SectionSpecialtiesHorizontalScroll />
      <SectionSpecialtiesCircular />
      <SectionTestimonialsCircular />
      <SectionContactCircular />
      <FooterCircular />
    </>
  )
}
